import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { useContext, useEffect, useMemo, useState } from 'react';

import { useGetSettlements } from '@/modules/Settlements/apiHooks';
import getTabsList from '@/modules/Settlements/components/Main/CrewSettlementsList/logic';
import SettlementCard from '@/modules/Settlements/components/Main/CrewSettlementsList/SettlementCard';
import { SettlementsContext } from '@/modules/Settlements/context/context';
import { ISettlements } from '@/modules/Settlements/types';
import { Pagination } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import CloudFence from '~/images/shared/CloudFence.svg';

const PER_PAGE = 5;
const TAB_QUERY_INDICATORE = 'status';

const CrewSettlementsList = () => {
  const { t } = useTranslation('common');
  const {
    state: { startDate, endDate },
  } = useContext(SettlementsContext);
  const { query } = useRouter();

  const [selectedAsset] = useStore((store) => store?.asset);
  const [page, setPage] = useState(1);
  const onPageChange = (page: number) => {
    setPage(page);
  };
  const status = isNaN(
    Number(
      query?.[TAB_QUERY_INDICATORE] === ''
        ? undefined
        : query?.[TAB_QUERY_INDICATORE]
    )
  )
    ? undefined
    : Number(query?.[TAB_QUERY_INDICATORE]);

  const { data } = useGetSettlements({
    entityId: selectedAsset?.id,
    startDate,
    endDate,
    pageNumber: page,
    pageSize: PER_PAGE,
    status: status as ISettlements.ISettlementsStatus,
  });
  // here

  const tabsList = useMemo(
    () =>
      getTabsList({
        t,
        isssuedCount: data?.issuedSettlementsCount || 0,
        paidCount: data?.paidSettlementsCount || 0,
        underIssuanceCount: data?.underIssuanceSettlementsCount || 0,
      }),
    [
      data?.issuedSettlementsCount,
      data?.paidSettlementsCount,
      data?.underIssuanceSettlementsCount,
      t,
    ]
  );

  // reset page number when change status's tab or change date
  useEffect(() => {
    setPage(1);
  }, [status]);

  return (
    <div className=''>
      <Tabs
        containerClassName='border border-b-xs border-background-disable border-opacity-2'
        getLabel={(item) => item?.label}
        getValue={(item) => item?.value}
        getCount={(item) => item?.count}
        tabsList={tabsList}
        variant='underline'
        tabQueryIndicator={TAB_QUERY_INDICATORE}
        allInfo={{
          name: t('all'),
          count: data?.settlementsTotalCount,
          value: 'all',
        }}
      />

      <div className='mt-16 '>
        {/* if no data found */}
        {data?.settlements?.length === 0 ? (
          <EmptyCard
            message={t('no-exported-settlements')}
            vector={<CloudFence />}
            variant='icon'
            fullSVG
          />
        ) : (
          <div className='mt-24'>
            {data?.settlements?.map((settlement) => (
              <div key={settlement?.id} className='mt-24'>
                <SettlementCard
                  settlement={settlement}
                  currency={selectedAsset?.currency || ''}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className='mt-24 flex justify-center'>
        <Pagination
          onPageChange={onPageChange}
          currentPage={page}
          totalCount={data?.totalCount || 0}
          perPage={PER_PAGE}
        />
      </div>
    </div>
  );
};
export { CrewSettlementsList };
